import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { Template } from '@utils/types/organization/export-template.ts';

export interface UpdateExportTemplatePayload {
  name: string;
  template_type: string;
  organization_id: number;
  template_docx: File | null;
  template_example: File | null;
  prompt: string | null;
}

const putExportTemplate = async (
  customerId: number,
  templateId: number,
  payload: UpdateExportTemplatePayload
) => {
  const formData = new FormData();
  formData.append('name', payload.name);
  formData.append('type', payload.template_type);
  formData.append('organization_id', payload.organization_id.toString());
  if (payload.prompt !== null && payload.prompt !== undefined) {
    formData.append('prompt', payload.prompt);
  }

  if (payload.template_docx) {
    formData.append('docx_template', payload.template_docx);
  }
  if (payload.template_example) {
    formData.append('example_template', payload.template_example);
  }

  const url = PUT_URL(
    customerId.toString(),
    templateId.toString()
  ).exportTemplateBo;

  const response = await Axios.put<Template>(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const useEditExportBoTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation<
    Template,
    AxiosError<BaseError>,
    {
      customerId: string;
      templateId: number;
      payload: UpdateExportTemplatePayload;
    }
  >(
    ({ customerId, templateId, payload }) =>
      putExportTemplate(Number(customerId), templateId, payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(QueryKeys.exportTemplates());
      },
      useErrorBoundary: false
    }
  );
};
